import axios, { AxiosResponse } from "axios";
import { certificado, firmaCertificado } from "../interfaces/Certificados";
import { IDatosRespuesta } from "../interfaces/RespuestaDTO";
import { ResponceApi } from "../interfaces/Responses";
const localBack : string = process.env.REACT_APP_BACK || ''; 
const APICATALOGO : string = '/api/Proyecto';



export default class CertificadoService{

    async GetCertificadosProyectoByIdInvestigador(idInv: number,token:any): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any>> = await axios.get(localBack+APICATALOGO+'/GetCertificadosProyecto/'+idInv,
        {
            headers: {
              Authorization: `Bearer ${token}`
            }
        });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetCerficadosFirmaProyectosByEmail(emailInv: string, token: any): Promise<ResponceApi<any>>{
        const response: AxiosResponse<any> = await axios.get(localBack+APICATALOGO+'/GetCertificadosByUser/' + emailInv,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return response.data;
    }


    async GenerarCertificadosFirmas(certificados: Array<firmaCertificado>, username: string, tipoFirma: string,token:any):Promise<IDatosRespuesta<firmaCertificado>>{
        try {
            // var formData = new FormData();
            
              const response: AxiosResponse<IDatosRespuesta<firmaCertificado>> = await axios.post(
                localBack + APICATALOGO + '/GenerarCertificadoFirmado/'+username+'&'+tipoFirma,
              certificados,
                {
                  headers: {
                      Authorization: `Bearer ${token}`,
                  },
                }
              );            
              if (response.data) {
                  //console.log(response.data)
                  return response.data;
              } else {
                  throw new Error('No se recibieron datos válidos.');
              }
            } catch (error) {
              console.error('Error al enviar la solicitud:', error);
              throw error; // Re-lanzar el error para que se maneje donde se llama a la función
            }
    }

    async BuscarCertificado(codigoCertificado: string):Promise<IDatosRespuesta<certificado>>{
      const response: AxiosResponse<any> = await axios.get(localBack+APICATALOGO+'/GetCertificadoByNombre/' + codigoCertificado,
        {
           
        })
        return response.data;
    }

}